// extracted by mini-css-extract-plugin
export default {"wrapper":"PopUp_wrapper__8coep","content":"PopUp_content__1dT1+","videoWrap":"PopUp_videoWrap__vgecq","video":"PopUp_video__lxlpu","closeBtn":"PopUp_closeBtn__m1hx0"};